import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationReportSpec from "./OrganisationReportSpec";

@Model()
class OrganisationReportSpecDateRange extends ApplicationRecord {
  static jsonapiType = "organisation_report_spec_date_ranges";

  @Attr() dateFrom: string;

  @Attr() dateTo: string;

  @BelongsTo() specification: OrganisationReportSpec;
}

export default OrganisationReportSpecDateRange;
